import React from 'react';
import { Pie } from 'react-chartjs-2';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import colors from '../../../shared/utils/colors';

const EventMetricsChart = (props) => {
  const { dataLabels, numbersChart, options } = props;

  const data = {
    labels: dataLabels,
    datasets: [
      {
        data: numbersChart,
        backgroundColor: colors,
        hoverBackgroundColor: colors,
        borderColor: 'rgba(255,255,255,0.54)',
      },
    ],
  };

  const legendOptions = {
    display: false,
  };

  return (
    <Pie data={data} legend={legendOptions} options={options} height={300} />
  );
};

EventMetricsChart.propTypes = {
  dataLabels: PropTypes.arrayOf(PropTypes.shape),
  numbersChart: PropTypes.arrayOf(PropTypes.shape).isRequired,
  options: PropTypes.shape(PropTypes.shape),
};

EventMetricsChart.defaultProps = {
  dataLabels: [],
  options: {},
};

export default withTranslation('common')(EventMetricsChart);
